import React from "react";
import moment from "moment";
import { useDispatch } from "react-redux";

import { removeFormErrors } from "store/form/actions";

import Field from "components/Field";
import Input from "components/Input";
import InputRow from "components/Input/Row";
import Button from "components/Button";
import Accordion from "components/Accordion";

import { useStateSelector } from "utils/field";
import Actions from "../Actions";

import sharedClasses from "features/Model/sharedStyles.module.scss";

const Loan = ({ accessor, change }) => {
    const dispatch = useDispatch();

    const loans = useStateSelector(`${accessor}`) || {
        _firstLoan: {
            amount: null,
            rate: null,
            term: null,
            adminFee: null,
        },
    };

    const addLoan = () => {
        change(`${accessor}`, {
            ...loans,
            [`${moment().format("YYYYMMDDHHmmssSS")}`]: {
                amount: null,
                rate: null,
                term: null,
                adminFee: null,
            },
        });
    };

    const removeLoan = (loan) => {
        const { [loan]: removedObj, ...remainingLoanObj } = loans;
        change(`${accessor}`, {
            ...remainingLoanObj,
        });
        dispatch(removeFormErrors(`${accessor}.${loan}`));
    };

    return (
        <>
            {Object.keys(loans).map((loan, ind) => {
                const loanAmount = loans[loan]?.amount || 0;
                const hasLoanAmount = !!loanAmount;
                const label = `Loan${hasLoanAmount ? ": $" + loanAmount.toFixed(2) : ""}`;

                return (
                    <Accordion
                        key={`${loan}-${ind}`}
                        className={sharedClasses.accordion}
                        heading={<span>{label}</span>}
                        large
                        hoverActions={
                            <Actions
                                accessor={accessor}
                                change={change}
                                handleDelete={() => removeLoan(loan)}
                                type="loan"
                            />
                        }
                    >
                        <div>
                            <InputRow gridTemplate="1fr 1fr 1fr 1fr">
                                <Field
                                    component={Input}
                                    name={`${accessor}.${loan}.amount`}
                                    label={`Loan Amount ($)`}
                                    type="number"
                                />
                                <Field
                                    component={Input}
                                    name={`${accessor}.${loan}.rate`}
                                    label={`Interest Rate (%)`}
                                    type="number"
                                    disabled={!hasLoanAmount}
                                />
                                <Field
                                    component={Input}
                                    name={`${accessor}.${loan}.term`}
                                    label={`Loan Term (yrs)`}
                                    type="number"
                                    disabled={!hasLoanAmount}
                                />
                                <Field
                                    component={Input}
                                    name={`${accessor}.${loan}.adminFee`}
                                    label={`Admin Fee (%)`}
                                    type="number"
                                    disabled={!hasLoanAmount}
                                />
                            </InputRow>
                        </div>
                    </Accordion>
                );
            })}
            <Button
                onClick={() => {
                    addLoan();
                }}
            >
                Add New Loan
            </Button>
        </>
    );
};

export default Loan;
